import axios from 'axios'

const API_URL = window.location.origin


export async function getPress() {
    return (await axios.get(API_URL + '/db-press.json')).data
}